import React from 'react';

export interface AuthCardFooterProps {
  children: React.ReactNode;
}

/** Centered block for auth card links, signup prompts, and policy text. */
export function AuthCardFooter({ children }: AuthCardFooterProps) {
  return <div className="auth-card-footer">{children}</div>;
}

export default AuthCardFooter;
